module.exports = __webpack_public_path__ + "img/homebtn1.d28101cd.png";